import * as yup from 'yup';


export function isValidID(id: string): boolean {
  // רק ספרות, השלמה ל-9 ספרות
  if (!/^\d{5,9}$/.test(id)) return false;
  id = id.padStart(9, "0");

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    const digit = Number(id[i]);
    let mult = i % 2 === 0 ? digit : digit * 2;
    if (mult > 9) mult -= 9;
    sum += mult;
  }
  return sum % 10 === 0;
}


export const yupIdValidation = yup.string()
  .matches(/^\d{9}$/, "מספר תעודת זהות חייב להכיל בדיוק 9 ספרות")
  .test('is-valid-id', 'תעודת זהות לא תקינה', (value) => {
    if (!value) return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      const digit = Number(value[i]);
      let mult = i % 2 === 0 ? digit : digit * 2;
      if (mult > 9) mult -= 9;
      sum += mult;
    }
    return sum % 10 === 0;
  });

